import { gql } from '@apollo/client';

export const TAG_QUERY = gql`
    query( $tagID: UUID! ) {
        tag( tagID: $tagID ) {
            node{
                id
                name
                slug
                metadata
                createdAt
                updatedAt
            }
        }
    }
`;
